import React from 'react';
import PropTypes from 'prop-types';

import Container from '../Container';

import ModalContent from './ModalContent';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalDialog = ({
  children,
}) => (
  <Container
    className="relative pointer-events-none overflow-hidden w-full h-full flex items-center lg:w-auto lg:max-h-full xl:w-3/4"
    role="document"
  >
    <ModalContent>
      {children}
    </ModalContent>
  </Container>
);

ModalDialog.propTypes = propTypes;

export default ModalDialog;
